import React from 'react';
import { faPlay } from '@fortawesome/pro-solid-svg-icons';
import { faTimes } from '@fortawesome/pro-regular-svg-icons';
import { classes, setProps, useVisibility } from '../../lib';
import { FontAwesomeIcon } from '../FontAwesomeIcon';
import { Modal } from '../Modal';
import { Button } from '../Button';
import Styles from './MediaThumbnail.module.less';
import { getImageDimensions } from '../../lib/landingPage';

const getPoster = (
    isVideo: boolean,
    content: React.ReactNode,
    poster?: string
) => {
    const posterUrl =
        poster ??
        'https://cdn.sanity.io/images/68gmuo7j/landing_page/537b300b4be01a9d99bc232c09a4f1072f35e184-1059x595.png';

    const { width, height } = getImageDimensions(posterUrl);
    return !isVideo ? (
        content
    ) : (
        <img
            width={width}
            height={height}
            loading="lazy"
            alt="Capa de vídeo de demonstração"
            src={
                poster ??
                'https://cdn.sanity.io/images/68gmuo7j/landing_page/537b300b4be01a9d99bc232c09a4f1072f35e184-1059x595.png'
            }
        />
    );
};

export type MediaThumbnailProps = {
    contentType?: 'video' | 'image' | 'other';
    content: React.ReactNode;
    poster?: string;
    className?: string;
};

export const MediaThumbnail = ({
    poster,
    content,
    contentType = 'other',
    className,
}: MediaThumbnailProps): JSX.Element => {
    const [visible, show, hide] = useVisibility();
    const isVideo = contentType === 'video';

    return (
        <div
            className={classes(
                Styles.content,
                Styles[contentType],
                className,
                isVideo && 'pointer'
            )}
            onClick={() => isVideo && show()}>
            {getPoster(isVideo, content, poster)}
            {isVideo && (
                <FontAwesomeIcon
                    icon={faPlay}
                    className={Styles.posterPlayButton}
                />
            )}
            {isVideo ? (
                <Modal
                    width="900px"
                    footer={null}
                    destroyOnClose
                    closable={false}
                    className={Styles.modalVideo}
                    visible={visible}
                    onCancel={hide}
                    onOk={hide}>
                    <Button
                        shape="circle"
                        type="default"
                        onClick={hide}
                        className={Styles.closeIcon}
                        icon={<FontAwesomeIcon icon={faTimes} />}
                    />
                    {setProps(content, { autoPlay: true, controls: true })}
                </Modal>
            ) : null}
        </div>
    );
};
